<template>
  <div class="scheduler-section">
    <h5 class="data-title">message send time</h5>
    <div class="send-time">
      <radios
          :currentValue="sendNow"
          :radios="[{ label: 'now', value: true, id: 'now' },
            { label: 'later', value: false, id: 'later' }]"
          @update="setScheduledTime">
      </radios>
    </div>

    <div :class="['scheduler-wrapper', 'text-center', scheduledTime === 'now' ? 'slide-up' : 'slide-down']">
      <label :class="['data-description', { ['error-label']: !validSendTime }]">select date and time</label>
      <flat-pickr v-if="config" v-model="later" :config="config" name="send_at_local" ref="datePicker"></flat-pickr>
      <span class="error-label error-message" v-if="!validSendTime">must select send time</span>
      <label>ensure this timezone is correct</label>
      <span>{{ currentMerchant.timezone }}</span>
      <p>currently {{ currentMerchantTime }}</p>

    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import flatPickr from 'vue-flatpickr-component'
  import { mapGetters, mapState } from 'vuex'
  import Radios from '../shared/Radios'

  export default {
    props: {
      adEnd: String,
      adStart: String,
      sendAtLocal: String,
      sendNow: Boolean,
    },

    name: 'Scheduler',

    components: {
      flatPickr,
      Radios,
    },

    data() {
      return {
        later: null,
        noInteraction: true,
        scheduledTime: 'now',
        validSendTime: true,
      }
    },

    methods: {
      onChangeTime(selectedDates, dateStr) {
        if (this.later === dateStr) { return }
        this.later = dateStr
        this.validateSentTime()
      },

      sendTimeUpdate() {
        const sendNow = this.scheduledTime === 'now',
          later = { send_at_local: this.later, send_now: false },
          now = { send_at_local: null, send_now: true }
        let scheduledSendTime = sendNow ? now : later
        this.$emit('updateCampaign', scheduledSendTime)
      },

      setScheduledTime(value) {
        this.scheduledTime = value ? 'now' : 'later'
        this.toggleScheduler()
      },

      toggleScheduler() {
        let interactions = {}
        if (this.scheduledTime === 'now') {
          this.validateSentTime()
        } else {
          interactions = { schedule: true }
          if (!this.noInteraction) { this.validateSentTime() }
        }
        if (this.noInteraction) { this.$emit('configUserInteractions', 'schedule', interactions) }
      },

      updateInteractions() {
        if (this.noInteraction) {
          this.noInteraction = false
          this.$emit('configUserInteractions', 'schedule', {})
        }
      },

      validateScheduler() {
        const schedulerErrors = this.validSendTime ? {} : { schedulerValid: this.validSendTime}
        this.$emit('isAllValid', 'scheduler', schedulerErrors)
      },

      validateSentTime() {
        const sendNow = this.scheduledTime === 'now'
        if (sendNow) {
          this.validSendTime = true
          this.later = null
        } else if (!sendNow && this.later) {
          this.updateInteractions()
          this.validSendTime = true
        } else {
          this.updateInteractions()
          this.validSendTime = false
        }
        this.validateScheduler()
        if (this.validSendTime) { this.sendTimeUpdate() }
      }
    },

    created() {
      this.scheduledTime = this.sendAtLocal? 'later' : 'now'
      this.later = this.sendAtLocal
    },

    computed: {
      config: function () {
        if (this.currentMerchant && moment.tz) {
          return {
            altFormat: "D, M j, Y h:i K",
            altInput: true,
            altInputClass: 'flatpickr-input',
            enableTime: true,
            dateFormat: 'Y-m-d H:i',
            maxDate: this.maxDate,
            minDate: this.minDate,
            onChange: this.onChangeTime,
            // AM/PM keyboard switch not triggering onChange
            // Use onValueUpdate until fixed
            // Not ideal because it makes additional API requests
            // Issue: https://github.com/flatpickr/flatpickr/issues/2224
            onClose: this.onChangeTime
          }
        }
      },
      
      maxDate: function () {
        return this.adEnd ? moment.utc(this.adEnd)?.format('YYYY-MM-DD HH:mm') : null
      },
      
      minDate: function () {
        const now = moment.tz(this.currentMerchant.merchant_time_zone),
            adTime = moment.utc(this.adStart),
            adStartsLater = adTime.unix() > now.unix(),
            startDate = adStartsLater ? adTime : now
        return startDate.format('YYYY-MM-DD HH:mm')
      },

      ...mapGetters([
        'currentMerchantTime'
      ]),
      ...mapState([
        'currentMerchant'
      ]),
    },

    watch: {
      sendAtLocal: function () {
        if (!this.sendAtLocal) {
          this.$refs.datePicker?.fp?.close()
          this.setScheduledTime(true)
        }
      },
    }
  }
</script>
